/*jslint white: true, nomen: true */
/*global angular, $, navigator */
(function() {
    'use strict';
  
    angular.module('app.common')
      .controller('LargeFooterRegionCtrl', [
        '$scope',
        '$location',
        function(
          $scope,
          $location
        ) {
            $scope.currentTab = 'communities';
            $scope.regions = regions;
            
            const tabMappings = {
                'communities': 'communities',
                'our-floorplans': 'our-floorplans',
                'move-in-ready': 'move-in-ready',
                'model-homes': 'model-homes'
            };
            
            $scope.$watch(function() {
                return $location.path();
            }, function(newPath) {
                if (newPath.includes('find-new-homes')) {
                    // Search the first tab that matches the route
                    const matchedTab = Object.keys(tabMappings).find(tab => newPath.includes(tab));
                    
                    if (matchedTab) {
                        $scope.currentTab = tabMappings[matchedTab];
                    }
                }
            });
         
        }]);
  }());
  